const Background = () => import('views/bg/Background')
const BlogCategory = () => import('views/blog/BlogCategory')
const BlogPost = () => import('views/blog/BlogPost')
const BlogQuestion = () => import('views/blog/BlogQuestion')
const BlogImage = () => import('views/blog/BlogImage')

export default {
  path: '/bg/blog',
  redirect: '/bg',
  name: 'Blog',
  title: '我的博客',
  icon: 'el-icon-document',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_user'] },
  children: [
    {
      path: '/bg/blog/category',
      name: 'AdminStoreConfig',
      title: '分类管理',
      icon: 'el-icon-document',
      component: BlogCategory,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/blog/post',
      name: 'BlogPost',
      title: '文章管理',
      icon: 'el-icon-document',
      component: BlogPost,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/blog/question',
      name: 'BlogQuestion',
      title: '面试题',
      icon: 'el-icon-document',
      component: BlogQuestion,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/blog/image',
      name: 'BlogImage',
      title: '图片列表',
      icon: 'el-icon-document',
      component: BlogImage,
      meta: { needAuth: true, roles: ['tnb_user'] }
    }
  ]
}
